import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

const BackToTop = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const check = () => setVisible(window.scrollY > 600);
    window.addEventListener("scroll", check, { passive: true });
    return () => window.removeEventListener("scroll", check);
  }, []);

  return (
    <button
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Voltar ao topo"
      className="fixed bottom-8 right-6 md:right-10 z-50 w-12 h-12 border border-white bg-black text-white flex items-center justify-center hover:bg-[#c0392b] hover:border-[#c0392b] transition-colors duration-250 cursor-pointer"
      style={{
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? "auto" : "none",
        transform: visible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 300ms ease, transform 300ms ease, background-color 250ms ease, border-color 250ms ease",
      }}
    >
      <ArrowUp size={20} />
    </button>
  );
};

export default BackToTop;
